/* eslint-disable */

/**
 * Declaration of the paleo utils class
 */

var paleo = paleo || {};

paleo.queryRegex = /_([a-zA-Z0-9\-_]+)/;
paleo.uid = 0;
paleo.defaultTz = 'Europe/Zurich';
paleo.dayjsInitialized = false;

/**
 * Generate and return a simple uid on the page
 * @returns {number}
 */
paleo.getUid = function () {
  return this.uid++;
};

/**
 * @return a map of query parameters
 * Code from http://stackoverflow.com/questions/2907482/how-to-get-the-query-string-by-javascript
 */
paleo.getQueryParameters = function () {
  var assoc = {};
  var decode = function (s) {
    return decodeURIComponent(s.replace(/\+/g, " "));
  };
  var queryString = location.search.substring(1);
  var keyValues = queryString.split('&');

  for (var i in keyValues) {
    var key = keyValues[i].split('=');
    if (key.length > 1 && key[0].match(this.queryRegex)) {
      assoc[decode(key[0].match(this.queryRegex)[1])] = decode(key[1]);
    }
  }

  return assoc;
};

/**
 * @return the parameter value of the given key
 * @param key
 */
paleo.getQueryParameter = function (key) {
  return paleo.getQueryParameters()[key];
};


/**
 * Change the given query parameter and keep previous values (other query parameters values).
 * Generate a pushstate on the history api
 * @param key
 * @param value
 */
paleo.setQueryParameterAndPush = function (key, value) {
  var parameters = this.getQueryParameters();

  if (value === null) {
    delete parameters[key];
  } else {
    parameters[key] = value;
  }

  this.setQueryParametersAndPush(parameters);
};

/**
 * Set the url parameters to the given array.
 * Generate a pushstate on the history api
 * @param parameters array of param_key => param_value
 */
paleo.setQueryParametersAndPush = function (parameters) {
  this.pushState(null, null, this.encodeQueryParameters(parameters));
};

/**
 * Call history.pushState and ensure the popstate event is fired (by default, the event is only fired when
 * the user click the browser's back button)
 */
paleo.pushState = function (object, title, url) {
  history.pushState(object, title, url);

  var event = document.createEvent('HTMLEvents');
  event.initEvent('popstate', true, true);
  document.dispatchEvent(event);
};

/**
 * Encode given parameters to a correct query string (?param1=value1&param2=value2)
 * @param parameters
 */
paleo.encodeQueryParameters = function (parameters) {
  var queryParameters = [];

  for (var key in parameters) {
    queryParameters.push('_' + encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key]));
  }

  return '?' + queryParameters.join('&');
};

/**
 * Initialize the day.js library
 */
paleo.initializeDayjs = function () {
  // Enable required plugins
  window.dayjs.extend(window.dayjs_plugin_isSameOrAfter);
  window.dayjs.extend(window.dayjs_plugin_isSameOrBefore);
  window.dayjs.extend(window.dayjs_plugin_timezone);
  window.dayjs.extend(window.dayjs_plugin_utc);

  // Set the default timezone
  window.dayjs.tz.setDefault(paleo.defaultTz);
};

/**
 * Return a date based on hashDate (or startDate if hashDate is badly formatted, and endDate if hashDate is bigger
 * than endDate)
 *
 * @param {window.dayjs} startDate
 *   Start date.
 * @param {window.dayjs} endDate
 *   End date.
 * @param {string} date
 *   Date (format 'yyyy-MM-dd')
 * @param {bool} supportAll
 *
 * @returns {window.dayjs}
 */
paleo.getDisplayDate = function (startDate, endDate, date, supportAll) {

  supportAll = supportAll || false;

  if (supportAll && date === 'all') {
    return date;
  }

  var hashDate = date === 'all' ? 'all' : paleo.getDate(date);

  if (hashDate === 'all' || !hashDate.isValid() || hashDate.isBefore(startDate)) {
    if (supportAll) {
      return 'all';
    }

    return startDate;
  }

  if (hashDate.isAfter(endDate)) {
    if (supportAll) {
      return 'all';
    }

    return endDate;
  }

  return hashDate;
};

/**
 * @param {string|int|null} date
 *   Given date (ISO 8601 string, Unix timestamp or empty to retrieve the current date).
 * @returns {window.dayjs}
 */
paleo.getDate = function (date) {
  if (!paleo.dayjsInitialized) {
    paleo.initializeDayjs();
  }

  switch (typeof date) {
    // From an ISO 8601 string or from a Unix timestamp
    case 'string':
    case 'number':
      return window.dayjs.tz(date);
    // If not defined or not supported, returns the current date
    case 'undefined':
    default:
      return window.dayjs.tz();
  }
};

/**
 * Returns default date.
 *
 * Return the date corresponding to today if today is between startDate
 * and endDate. Otherwise return startDate.
 *
 * @param {window.dayjs} startDate
 *   Instance of Date for start date.
 * @param {window.dayjs} endDate
 *   Instance of Date for end date.
 * @param {bool} supportAll
 *
 * @return {window.dayjs}|string
 *   Date or 'all'.
 */
paleo.getDefaultDate = function (startDate, endDate, supportAll) {
  supportAll = supportAll || false;

  var now = paleo.getDate();

  // We need a local End Date here.
  // end date is "Sunday XX XXXX" at "0h00" so if today is sunday,
  // now.getTime() will always be < endDate.getTime()
  // So we will add 24 hours to end date.
  // We use here a local Date object, because we don't want to alter the real
  // instance of endDate.
  var localEndDate = endDate.add(1, 'day');

  // Remove 3 hours to test current day (a paleo day ends at 3 AM the next day)
  now = now.subtract(3, 'hour');

  if (now.isSameOrAfter(startDate) && now.isSameOrBefore(localEndDate)) {
    return now;
  } else {
    if (supportAll) {
      return 'all';
    } else {
      return startDate;
    }
  }
};

/**
 * Returns today date.
 *
 * Return the date corresponding to today if today is between startDate
 * and endDate. Otherwise return startDate.
 *
 * @param {window.dayjs} startDate
 *   Instance of Date for start date.
 * @param {window.dayjs} endDate
 *   Instance of Date for end date.
 * @param {bool} supportAll
 *
 * @return {window.dayjs}|string
 *   Date or 'all'.
 */
paleo.getDefaultFormattedDate = function (startDate, endDate, supportAll) {

  var result = paleo.getDefaultDate(startDate, endDate, supportAll);

  if (result === 'all') {
    return 'all';
  } else {
    return result.format('YYYY-MM-DD');
  }

};

/**
 * To get a list of classes that you can add to the <html> or <body>.
 * @param {string} user_agent
 *   Optional user agent string. Defaults to navigator's user agent.
 */
paleo.getUserAgentClasses = function(user_agent) {
  var classes = [],
      match = false,
      ua = (arguments.length === 1) ? user_agent : navigator.userAgent;

  // 1. Try to find the OS type.
  if ((match = ua.match(/\b(iPod|iPad|iPhone)\b/))) {
    classes.push(match[1].toLowerCase());
    classes.push('ios');
    if ((match = ua.match(/\bCPU(?: iPhone)? OS ((\d+)[_\d]*) like Mac OS X\b/))) {
      classes.push('ios-' + match[2],
        'ios-' + match[1].replace(/[^\d]+/g, '-'));
    }
  }
  else if ((match = ua.match(/\bAndroid ((\d+)[\.\d]+);/i))) {
    classes.push('android',
      'android-' + match[2],
      'android-' + match[1].replace(/[^\d]+/g, '-'));
  }
  else if (ua.match(/\bIEMobile\b/)) {
    classes.push('ie-mobile');
  }
  else if ((match = ua.match(/\bMac OS X ([_\d]+)/))) {
    classes.push('mac-os-x',
      'mac-os-x-' + match[1].replace(/[^a-z\d]+/g, '-'));
  }
  else if ((match = ua.match(/\bWindows ((?:NT )?[\.\d]+)/))) {
    classes.push('windows',
      'windows-' + match[1].toLowerCase().replace(/[^a-z\d]+/g, '-'));
  }
  else if (ua.match(/\bLinux /)) {
    classes.push('linux');
  }

  // 2. Then try to find the browser.
  if ((match = ua.match(/\bEdge\/(\d+)/))) {
    classes.push('edge', 'edge-' + match[1]);
  }
  else if ((match = ua.match(/\bMozilla\b.*Firefox\/(\d+)/))) {
    classes.push('firefox',
      'firefox-' + match[1]);
  }
  else if ((match = ua.match(/\bMozilla\b.*MSIE ((\d+)\.\d+\w*); (?:Windows|Macintosh)\b/i))) {
    classes.push('ie',
      'ie-' + match[2],
      'ie-' + match[1].replace(/[^a-z\d]+/g, '-'));
  }
  else if ((match = ua.match(/\bMozilla\b.*\bTrident\/([\d]+)\b.*\brv:([\d]+)/i))) {
    classes.push('ie',
      'ie-' + match[2],
      'trident-' + match[1]);
  }
  else if ((match = ua.match(/\bChrome\/(\d+)\./))) {
    classes.push('chrome',
      'chrome-' + match[1]);
  }
  else if ((match = ua.match(/\bVersion\/((\d+)[\.\d]+) Safari\b/))) {
    classes.push('safari',
      'safari-' + match[2],
      'safari-' + match[1].replace(/[^\d]+/g, '-'));
  }
  else if ((match = ua.match(/\bVersion\/((\d+)[\.\d]+) Mobile Safari\b/))) {
    classes.push('mobile-safari',
      'mobile-safari-' + match[2],
      'mobile-safari-' + match[1].replace(/[^\d]+/g, '-'));
  }

  return classes;
};

/**
 * Paleo Mixin namespace
 * This namespace contains utility functions to check that we are in a specific media query mode.
 * Checking the screen width is not enough (see
 * http://stackoverflow.com/questions/19291873/window-width-not-the-same-as-media-query).
 * @type {{}}
 */
paleo.mixin = {};

/**
 * Correspond to tablet-portrait media query
 * @returns {*|Model.matches|r}
 */
paleo.mixin.isTabletPortrait = function() {
  return window.matchMedia('(min-width: 768px)').matches;
};

/**
 * Correspond to tablet-landscape media query
 * @returns {*|Model.matches|r}
 */
paleo.mixin.isTabletLandscape = function() {
  return window.matchMedia('(min-width: 1024px)').matches;
};

/**
 * Correspond to tablet-desktop media query
 * @returns {*|Model.matches|r}
 */
paleo.mixin.isDesktop = function() {
  return window.matchMedia('(min-width: 1280px)').matches;
};

/**
 * Some tools
 * @type {{}}
 */
paleo.tools = {};

/**
 *
 * @return {string}
 */
paleo.tools.getHref = function(){
  return window.location.protocol + '//' + window.location.hostname + window.location.pathname;
};

/**
 * Drupal behaviors
 */
(function ($) {
  Drupal.behaviors.paleo = {
    attach: function(context, settings) {

      // Add some CSS classes to the <html> tag in order to know the user agent
      // and the underlaying OS.
      var $html = $('html:not(.paleo-processed)', context);
      if ($html.length > 0) {
        var classes = paleo.getUserAgentClasses();
        if (classes.indexOf('chrome') > -1) {
          classes.push('svg-bad-support');
        }
        else {
          classes.push('svg-good-support');
        }
        classes.push('paleo-processed');
        $html.addClass(classes.join(' ')).removeClass('no-js');
      }

    } // end attach()
  };
})(jQuery);
